module.exports = __webpack_public_path__ + "static/media/add-product.c160d7dc.png";